import { mutatorAction } from 'satcheljs';
import { mailListItemAnimationStore } from '../store/Store';
import { ActionId } from '../util/actionId';

export const clearAnimationActions = mutatorAction(
    'clearAnimationAction',
    (animationAction?: ActionId, animationRowIds?: string[], onAnimationComplete?: () => void) => {
        mailListItemAnimationStore.animationAction = null;
        mailListItemAnimationStore.animationRowIds = null;
        mailListItemAnimationStore.animationCallbacks = null;
    }
);
